import { formatDate as format, isDateValid as validDate, toDate as tdate } from '@trupropel/vcp-commons';
import moment from 'moment';

const locale = navigator.languages?.[0] || navigator.language;

export const isDateValid = (date: string | Date): boolean => validDate(date, locale);

export const formatDate = (date: Date) => format(date, locale);

export const toDate = (date: string | Date): Date => tdate(date, locale);

export const daysBetweenDates = (date1: Date, date2: Date) => {
  return moment(date1).diff(moment(date2), 'days');
};

export const dateIsFromToday = (date: Date) => {
  const momentDate = moment(date);
  return momentDate.isSame(new Date(), 'day');
};

export const dateIsFromYesterday = (date: Date) => {
  const momentDate = moment(date);
  return momentDate.isSame(moment().subtract(1, 'day'), 'day');
};

export const dateIsLessThanWeekAgo = (date: Date) => {
  const momentDate = moment(date);
  return Math.abs(momentDate.startOf('day').diff(moment().startOf('day'), 'day')) < 7;
};

export const dateInLastXSeconds = (date: Date, seconds: number) => {
  const momentDate = moment(date);
  const secondsAgo = moment.duration(moment().diff(momentDate)).asSeconds();
  return secondsAgo <= seconds;
};

export const getDayOfWeekOfDate = (date: Date) => {
  const momentDate = moment(date);
  return momentDate.format('dddd');
};

/*
 * Adjusts the passed date, removing the user's local timezone offset
 * @param stringDate date in string format
 * @returns an object of type Date with the correct UTC offset
 */
export const createUTCDate = (stringDate: string): Date => {
  const date = new Date(stringDate);

  // https://www.youtube.com/watch?v=oKFb2Us9kmg
  // Methods on Date Object will convert from UTC to users timezone
  // Set minutes to current minutes (UTC) + User local time UTC offset
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());

  return date;
};
